import { Breadcrumbs, Link, Typography } from "@mui/material";
import { useMemo } from "react";

// Components
import RefreshButton from "../../../../../common/components/refresh_button";
import PrimaryButton from "../../../../../common/components/primary_button";
import {
  PageTopBar,
  ThreeSlotLayout,
} from "../../../../../common/components/page_top_bar";
import FormContainer from "../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../common/components/default_form_input";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { CustomFooterServicos } from "./components/CustomFooterServicos";

// Inputs
import { FormDatePickerInput } from "../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import { FormRadioGroupInput } from "../../../../../common/components/masked_inputs/react_forms/form_radio_group_input";
import { DropDownFornecedor } from "../../../../../common/components/dropdown_fornecedor";
import { DropDownCentroCusto } from "../../../../../common/components/dropdown_centro_custo";

// Models & Columns
import { GenerateServicoColumns } from "./columns/contrato_servico";
import { GenerateArquivoColumns } from "./columns/contrato_arquivo";
import { GenerateInformacoesColumns } from "./columns/contrato_informacoes";

// ViewModel
import { useContratoCadastroViewModel } from "../../viewModels/contrato_cadastro_view_model";
import { ContratoServicoLista } from "../../../domain/models/contrato_servico_lista";
import { ContratoArquivoLista } from "../../../domain/models/contrato_arquivo_lista";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import { ContratoInformacoesLista } from "../../../domain/models/contrato_informacoes_lista";
import { Header } from "./components/header";
import { BackButton } from "../../../../../common/components/back_button";
import { ServicoModal } from "./components/servico_modal";
import { ContratoServicoForm } from "../../schemas/Contrato/contrato_servico";
import { DocumentosModal } from "./components/documentos_modal";
import { ContratoArquivoForm } from "../../schemas/Contrato/contrato_arquivo";
import { InforModal } from "./components/informacoes_modal";
import { ContratoInformacoesForm } from "../../schemas/Contrato/contrato_informacoes";
import BottomBar from "../../../../../common/components/bottom_bar";
import { isValidId } from "../../../../../common/utils/utils";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";
import { DefaultFormMoneyInput } from "../../../../../common/components/default_form_money_input";
import { MedicoesContratoModal } from "./components/medicao_modal";

export const Contrato_Cadastro = () => {
  const viewModel = useContratoCadastroViewModel();
  const ContratoServicoListaColumns = useMemo(() => {
    return GenerateServicoColumns({
      onActionEditar: viewModel.handleEdicaoServicoOpenState,
      onActionDeletar: viewModel.handleDeleteServicoModalOpenState,
    });
  }, [viewModel]);

  const ContratoArquivoistaColumns = useMemo(() => {
    return GenerateArquivoColumns({
      onActionEditar: viewModel.handleEdicaoArquivoOpenState,
      onActionDeletar: viewModel.handleDeleteArquivoModalOpenState,
    });
  }, [viewModel]);

  const QualidadeInformacoesListaColumns = useMemo(() => {
    return GenerateInformacoesColumns({
      onActionEditar: viewModel.handleEdicaoInformacoesOpenState,
      onActionDeletar: viewModel.handleDeleteInformacoesModalOpenState,
    });
  }, [viewModel]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex items-center gap-2">
               <PrimaryButton
                type="button"
                onClick={() => viewModel.handleMedicaoOpenState(true)}
                buttonColor={"primary-green"}
              >
                Medições
              </PrimaryButton>
             

              <BackButton onClick={viewModel.handleVoltarContrato} />
            </div>
          }
        />
      </PageTopBar>
      <form>
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Terceirização
            </Link>
            <Typography className="text-primary-green">
              Contrato Lista
            </Typography>
            <Typography className="text-primary-green">
              Cadastro Contrato
            </Typography>
          </Breadcrumbs>
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">
                Cadastro de Contrato
              </h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>
          </div>
          <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">
            <FormContainer title={"Informações Gerais"} arrangement="fullRow">
              <div className="flex flex-col w-full gap-4 mt-4">
                <div className="flex flex-col gap-2">
                  <div className="flex items-center gap-4">
                    <span className="font-semibold w-40">Status:</span>
                    <FormRadioGroupInput
                      name="Status"
                      readOnly={viewModel.saving}
                      options={[
                        { id: 0, label: "Em Andamento" },
                        { id: 1, label: "Paralisado" },
                        { id: 2, label: "Encerrado" },
                      ]}
                      reactHookForm={viewModel.hookForm}
                    />
                  </div>

                  <div className="flex items-center gap-4">
                    <span className="font-semibold w-40">
                      Contrato Assinado:
                    </span>
                    <FormRadioGroupInput
                      name="ContratoAssinado"
                      readOnly={viewModel.saving}
                      options={[
                        { id: 0, label: "Assinado por todos" },
                        { id: 3, label: "Apenas a assinatura da empresa" },
                        { id: 1, label: "Não Assinado" },
                        { id: 2, label: "Não se Aplica" },
                      ]}
                      reactHookForm={viewModel.hookForm}
                    />
                  </div>
                </div>

                <div className="border-t border-gray-200 my-2"></div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <DefaultFormInput
                    name="NumeroContrato"
                    label="N° do Contrato"
                    required={true}
                    reactHookForm={viewModel.hookForm}
                  />
                  <FormDatePickerInput
                    name="DataDe"
                    label="Início Previsto"
                    reactHookForm={viewModel.hookForm}
                  />
                  <FormDatePickerInput
                    name="DataAte"
                    label="Término Previsto"
                    reactHookForm={viewModel.hookForm}
                  />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <DropDownFornecedor
                    name="IdFornecedor"
                    label="Fornecedor"
                    readOnly={viewModel.saving}
                    tercerizacao={true}
                    FornServico={true}
                    reactHookForm={viewModel.hookForm}
                  />
                  <DropDownCentroCusto
                    name="IdCentroCusto"
                    label="Centro de Custo"
                    readOnly={viewModel.saving}
                    reactHookForm={viewModel.hookForm}
                  />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <DefaultFormMoneyInput
                    name="ValorContrato"
                    label="Valor Contrato"
                    reactHookForm={viewModel.hookForm}
                  />
                  <DefaultFormMoneyInput
                    name="ValorMedido"
                    label="Valor Medido"
                    readOnly={true}
                    reactHookForm={viewModel.hookForm}
                  />
                  <DefaultFormMoneyInput
                    name="ValorRestante"
                    label="Valor Restante"
                    readOnly={true}
                    reactHookForm={viewModel.hookForm}
                  />
                </div>
                <div className="flex flex-col gap-1">
                  <span className="font-semibold">Escopo do Contrato</span>
                  <DefaultFormInput
                    name="Escopo"
                    multiline={true}
                    rows={6}
                    reactHookForm={viewModel.hookForm}
                  />
                </div>
                <div className="flex flex-col gap-4 mt-2">
                  <div className="flex items-center justify-between">
                    <span className="font-medium">
                      O PGR está conforme os requisitos da empresa?
                    </span>
                    <div className="min-w-[300px]">
                      <FormRadioGroupInput
                        name="StatusPcmat"
                        readOnly={viewModel.saving}
                        options={[
                          { id: 0, label: "Sim" },
                          { id: 1, label: "Não" },
                          { id: 2, label: "Não se Aplica" },
                        ]}
                        reactHookForm={viewModel.hookForm}
                      />
                    </div>
                  </div>

                  <div className="flex items-center justify-between">
                    <span className="font-medium">
                      O PCMSO está conforme os requisitos da empresa?
                    </span>
                    <div className="min-w-[300px]">
                      <FormRadioGroupInput
                        name="StatusPcmso"
                        readOnly={viewModel.saving}
                        options={[
                          { id: 0, label: "Sim" },
                          { id: 1, label: "Não" },
                          { id: 2, label: "Não se Aplica" },
                        ]}
                        reactHookForm={viewModel.hookForm}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </FormContainer>

            {/* SEÇÃO Servico */}
            <div className="w-40 mt-4  mb-4">
              <PrimaryButton
                type="button"
                onClick={viewModel.handleServico}
                buttonColor={"primary-green"}
              >
                Novo Serviço
              </PrimaryButton>
            </div>

            {viewModel.ListaServico.length > 0 ? (
              <>
                <StyledDataGrid
                  tableName="Contrato Serviço"
                  disableColumnMenu={false}
                  getRowId={(row: ContratoServicoLista) =>
                    row.IdContratoServico
                  }
                  columns={ContratoServicoListaColumns}
                  loading={viewModel.loadingServico}
                  rows={viewModel.ListaServico}
                  rowCount={viewModel.paginationServico.totalItems}
                  sx={{
                    "& .status-header": {
                      backgroundColor: "#AFDFD5",
                      color: "#000",
                    },
                  }}
                  slots={{
                    footer: () => (
                      <CustomFooterServicos
                        totalValorTotal={viewModel.totaisServico.total}
                        totalValorMedido={viewModel.totaisServico.medido}
                      />
                    ),
                  }}
                  autoHeight={true}
                  textSize="medio"
                  getRowHeight={() => "auto"}
                  pageSizeOptions={[10]}
                  paginationMode="server"
                  paginationModel={{
                    page: viewModel.paginationServico.page - 1,
                    pageSize: viewModel.paginationServico.rowsPerPage,
                  }}
                />
              </>
            ) : (
              <></>
            )}

            {/* SEÇÃO Arquivo */}
            <div className="w-40 mt-4  mb-4">
              <PrimaryButton
                type="button"
                onClick={viewModel.handleArquivo}
                buttonColor={"primary-green"}
              >
                Novo Arquivo
              </PrimaryButton>
            </div>

            {viewModel.ListaArquivo.length > 0 ? (
              <>
                <StyledDataGrid
                  tableName="Contrato de Arquivo"
                  disableColumnMenu={false}
                  getRowId={(row: ContratoArquivoLista) =>
                    row.IdContratoArquivo
                  }
                  columns={ContratoArquivoistaColumns}
                  loading={viewModel.loadingArquivo}
                  rows={viewModel.ListaArquivo}
                  rowCount={viewModel.paginationArquivo.totalItems}
                  sx={{
                    "& .status-header": {
                      backgroundColor: "#AFDFD5",
                      color: "#000",
                    },
                  }}
                  autoHeight={true}
                  textSize="medio"
                  getRowHeight={() => "auto"}
                  pageSizeOptions={[10]}
                  paginationMode="server"
                  paginationModel={{
                    page: viewModel.paginationArquivo.page - 1,
                    pageSize: viewModel.paginationArquivo.rowsPerPage,
                  }}
                />
              </>
            ) : (
              <></>
            )}

            <Header
              onClearFilters={viewModel.handleClear}
              DataPesquisa={viewModel.filtersInformacoes.Data}
              DescricaoPesquisa={viewModel.filtersInformacoes.DescInformacoes}
              handleDataChange={viewModel.handleDataChange}
              handleDescricaoChange={viewModel.handleDescricaoChange}
            />
            {/* SEÇÃO Informacoes */}
            <div className="w-40 mt-4  mb-4">
              <PrimaryButton
                type="button"
                onClick={viewModel.handleInformacoes}
                buttonColor={"primary-green"}
              >
                Nova Informação
              </PrimaryButton>
            </div>

            {viewModel.ListaInformacoes.length > 0 ? (
              <>
                <StyledDataGrid
                  tableName="Diario Obras Informações "
                  disableColumnMenu={false}
                  getRowId={(row: ContratoInformacoesLista) =>
                    row.IdContratoInformacoes
                  }
                  columns={QualidadeInformacoesListaColumns}
                  loading={viewModel.loadingInformacoes}
                  rows={viewModel.ListaInformacoes}
                  rowCount={viewModel.paginationInformacoes.totalItems}
                  sx={{
                    "& .status-header": {
                      backgroundColor: "#AFDFD5",
                      color: "#000",
                    },
                  }}
                  autoHeight={true}
                  textSize="medio"
                  getRowHeight={() => "auto"}
                  pageSizeOptions={[10]}
                  paginationMode="server"
                  paginationModel={{
                    page: viewModel.paginationInformacoes.page - 1,
                    pageSize: viewModel.paginationInformacoes.rowsPerPage,
                  }}
                />
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
        <BottomBar>
          <div className="w-full h-full items-center justify-between flex p-4 gap-4">
            <div>
              {isValidId(viewModel.IdContrato) && (
                <PrimaryButton
                  buttonColor="yellow"
                  onClick={() => viewModel.handleOpenChangeHistory(null, null)}
                >
                  <span className="text-xs">Historico de alterações</span>
                </PrimaryButton>
              )}
            </div>
            <div className="flex flex-row gap-4 ml-auto">
              <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                <h1
                  className="text-sm text-black dark:text-white"
                  onClick={viewModel.handleVoltarContrato}
                >
                  Cancelar
                </h1>
              </div>
              <div className="w-[130px]">
                {viewModel.saving ? (
                  <PrimaryButton>Salvando...</PrimaryButton>
                ) : (
                  <PrimaryButton
                    type="submit"
                    onClick={viewModel.hookForm.handleSubmit(
                      viewModel.handleContratoSubmit,
                    )}
                    startIcon={
                      <DynamicIcon
                        nameIcon="CheckRounded"
                        size={25}
                        className="text-white"
                      />
                    }
                  >
                    Salvar
                  </PrimaryButton>
                )}
              </div>
            </div>
          </div>
        </BottomBar>
      </form>

      <ChangeHistoryModal changeHistoryHandler={viewModel.changeHistory} />
      <MedicoesContratoModal
        open={viewModel.openMedicao}
        medicoes={viewModel.selectedMedicoes ?? []}
        onClose={() => {
          viewModel.setOpenMedicao(false);
          viewModel.setSelectedMedicoes([]);
        }}
      />
      <DeleteDialog
        open={viewModel.servicoDeleteModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeleteServicoModalOpenState(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirmaServico}
      />

      <DeleteDialog
        open={viewModel.ArquivoDeleteModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeleteArquivoModalOpenState(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirmaArquivo}
      />
      <DeleteDialog
        open={viewModel.openDeleteArquivoModal}
        saving={viewModel.saving}
        onClose={() =>
          viewModel.handleArquivoDeleteOpenState(null, null, false)
        }
        title={`Você realmente deseja excluir este arquivo?`}
        onDelete={viewModel.handleConfirmarDeletarArquivo}
      />
      <DeleteDialog
        open={viewModel.informacoesDeleteModal}
        saving={viewModel.saving}
        onClose={() =>
          viewModel.handleDeleteInformacoesModalOpenState(null, false)
        }
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirmaInformacoes}
      />
      <ServicoModal
        open={viewModel.openServico}
        IdContrato={viewModel.IdContrato}
        saving={viewModel.saving}
        selectedServico={
          (viewModel.selectedServico ??
            null) as unknown as ContratoServicoForm | null
        }
        onSubmit={viewModel.handleServicoSubmit}
        onClose={() => viewModel.setOpenServico(false)}
        onOpenChangeHistory={(id, tabelaTipo) =>
          viewModel.handleOpenChangeHistory(id, tabelaTipo)
        }
      />

      <InforModal
        open={viewModel.openInformacoes}
        IdContrato={viewModel.IdContrato}
        saving={viewModel.saving}
        selectedInfo={
          (viewModel.selectedInformacoes ??
            null) as unknown as ContratoInformacoesForm | null
        }
        onSubmit={viewModel.handleInformacoesSubmit}
        onClose={() => viewModel.setOpenInformacoes(false)}
        onOpenChangeHistory={(id, tabelaTipo) =>
          viewModel.handleOpenChangeHistory(id, tabelaTipo)
        }
      />

      <DocumentosModal
        open={viewModel.openArquivo}
        IdContrato={viewModel.IdContrato}
        saving={viewModel.saving}
        selectedArquivo={
          (viewModel.selectedArquivo ??
            null) as unknown as ContratoArquivoForm | null
        }
        handleDownload={viewModel.handleDownload}
        handleArquivoDeleteOpenState={viewModel.handleArquivoDeleteOpenState}
        onSubmit={viewModel.handleArquivoSubmit}
        onClose={() => viewModel.setOpenArquivo(false)}
        onOpenChangeHistory={(id, tabelaTipo) =>
          viewModel.handleOpenChangeHistory(id, tabelaTipo)
        }
        hookForm={viewModel.hookFormArquivo}
      />
    </>
  );
};
